import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('geometryShapes');

export const check = () => useBasicAuth.checkToken();

export const findAllGeometryShapesByEstadoSemCor = (id) => 
  axios.get(urlAPI + "/estadoSemCor/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const searchGeometryShapes = (request) => 
  axios.post(urlAPI + "/search" , JSON.stringify(request), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });





// export const findAllByBrasil = () => 
//   axios.get(urlAPI + "/byBrasil", environment.HEADER)
//   .then(({data}) => data)
//   .catch(e => {
//     useBasicAuth.handleError(e);
//   });

export const findAllByEstado = (id) => 
  axios.get(urlAPI + "/byEstado/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllByCidade = (id) => 
  axios.get(urlAPI + "/byCidade/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });








// export const findAllBySubstanciaBrasil = (subs) => 
//   axios.get(urlAPI + "/bySubstanciaBrasil/" + subs, environment.HEADER)
//   .then(({data}) => data)
//   .catch(e => {
//     useBasicAuth.handleError(e);
//   });

export const findAllBySubstanciaEstado = (subs, id) => 
  axios.get(urlAPI + "/bySubstanciaEstado/" + subs + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllBySubstanciaCidade = (subs, id) => 
  axios.get(urlAPI + "/bySubstanciaCidade/" + subs + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });






// export const findAllByGeologiaBrasil = (simb1000) => 
//   axios.get(urlAPI + "/byGeologiaBrasil/" + simb1000, environment.HEADER)
//   .then(({data}) => data)
//   .catch(e => {
//     useBasicAuth.handleError(e);
//   });

export const findAllByGeologiaEstado = (simb1000, id) => 
  axios.get(urlAPI + "/byGeologiaEstado/" + simb1000 + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllByGeologiaCidade = (simb1000, id) => 
  axios.get(urlAPI + "/byGeologiaCidade/" + simb1000 + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });